import { Dispatch } from 'react';

import OrderService from 'src/services/order.service';
import { IOrder } from 'src/interfaces/order';
import { request } from 'src/utils';

import {
  FETCH_ORDER,
  FETCH_ORDERS_BY_CUT_ORDER,
  FETCH_MEASUREMENTS_FROM_ORDER,
  CLEAR_ORDERS,
  OrderActionTypes,
} from './types';

export const fetchOrder =
  (id: string) => async (dispatch: Dispatch<OrderActionTypes>) => {
    try {
      const response: IOrder = await OrderService.current(id);

      dispatch({
        type: FETCH_ORDER,
        payload: response,
      });

      return response;
    } catch (err) {
      request.errors(err);
    }
  };

export const fetchOrdersByCutOrder =
  (name: string) => async (dispatch: Dispatch<OrderActionTypes>) => {
    try {
      const response: IOrder[] = await OrderService.fetchOrdersByCutOrder(name);

      dispatch({
        type: FETCH_ORDERS_BY_CUT_ORDER,
        payload: response,
      });

      return response;
    } catch (err) {
      request.errors(err);
    }
  };

export const fetchMeasurementsFromOrder =
  (orderId: string) => async (dispatch: Dispatch<OrderActionTypes>) => {
    try {
      const response: IOrder = await OrderService.fetchMeasurementsFromOrder(
        orderId
      );

      dispatch({
        type: FETCH_ORDER,
        payload: response,
      });

      dispatch({
        type: FETCH_MEASUREMENTS_FROM_ORDER,
        payload: response.orderSizes,
      });

      return response;
    } catch (err) {
      request.errors(err);
    }
  };

export const clearOrders =
  () => async (dispatch: Dispatch<OrderActionTypes>) => {
    dispatch({
      type: CLEAR_ORDERS,
    });
  };
